module.exports = __webpack_public_path__ + "img/2icon@2x.f5b57b5b.png";